/** THE SWING'S TIMELINE (LS-207). `attack` counts down from `total`: above
 *  `live` is the wind-up (three frames, the blade pulled back), from `live`
 *  down to `follow` is the strike (seven frames, the arc, the hitbox, the
 *  smear), and from `follow` to zero is the follow-through (twelve frames:
 *  the blade carries on past the arc and eases back, the body recovers) --
 *  out of which the next press starts the next swing at once. Vijay: "we
 *  need more swing frames and it needs to be faster, more follow through
 *  frames for sure on first swing". Short anticipation, fast action, long
 *  follow-through: the strike is quicker than it was and the swing is
 *  longer, and every pose, hitbox and cue reads these three numbers. */
export const SWING = { total: 22, live: 19, follow: 12 };
export const SWING_BUFFER = 7;

/** Shared vertical motion for the projected rig and its 2D fallback. */
export function axeMotion(kind: string, attack: number) {
  if (attack <= 0 || (kind !== 'chop' && kind !== 'heave' && kind !== 'sweep')) return null;
  const u = Math.max(0, Math.min(1, (SWING.live - attack) / (SWING.live - SWING.follow)));
  const wind = Math.max(0, Math.min(1, (attack - SWING.live) / (SWING.total - SWING.live)));
  const settling = attack <= SWING.follow ? attack / SWING.follow : 1;
  const winding = attack > SWING.live;
  return {
    /* THE SWEEP IS THE TORCH'S (LS-336): it goes DOWN and stays down, dragging
     * the flame along the ground, where a chop comes over the top and a heave
     * comes up from under. Held low for the whole strike, which is what makes
     * it readable at sixteen pixels beside the other two. */
    lift: (kind === 'chop' ? (winding ? 3 + 4 * (1 - wind) : 7 - 9 * u)
      : kind === 'sweep' ? -2 - 3 * u
      : -3 + 10 * u) * settling,
    reach: winding ? 3.5 + (1 - wind) * 2 : attack > SWING.follow ? 6.5 : 3 + 3 * settling,
    crouch: (kind === 'chop' ? u * 2 : kind === 'sweep' ? 1.6 : 2 - u * 3) * settling,
  };
}
